import { HttpInterceptorFn } from '@angular/common/http';

export const apiErrorInterceptor: HttpInterceptorFn = (req, next) => next(req);
